import { ReceiptText } from "lucide-react";

export default function Empty({ title, description }: { title: string; description: string }) {
  return (
    <div className="empty">
      <ReceiptText size={28} />
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
}
